import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import LandingGulf from "./pages/LandingGulf";
import LandingAI from "./pages/LandingAI";
import LandingEg from "./pages/LandingEg";
import EgAbout from "./pages/eg/About";
import EgRefund from "./pages/eg/Refund";
import EgCommunity from "./pages/eg/Community";
import EgSample from "./pages/eg/Sample";
import EgContact from "./pages/eg/Contact";
import GulfAbout from "./pages/gulf/About";
import GulfRefund from "./pages/gulf/Refund";
import GulfCommunity from "./pages/gulf/Community";
import GulfSample from "./pages/gulf/Sample";
import GulfContact from "./pages/gulf/Contact";
import LandingPink from "./pages/LandingPink";
import LandingReply from "./pages/LandingReply";
import ReplySession from "./pages/ReplySession";
import LandingIPO from "./pages/LandingIPO";
import IPOCheckout from "./pages/IPOCheckout";
import IPODownload from "./pages/IPODownload";
import LandingCourse from "./pages/LandingCourse";
import CourseCheckout from "./pages/CourseCheckout";
import CourseDownload from "./pages/CourseDownload";
import PerfAdsAdmin from "./pages/PerfAdsAdmin";
import LandingSeven from "./pages/seven/LandingSeven";
import CheckoutSeven from "./pages/seven/CheckoutSeven";
import SuccessSeven from "./pages/seven/SuccessSeven";
import DashboardSeven from "./pages/seven/DashboardSeven";
import ProgramSeven from "./pages/seven/ProgramSeven";
import CardsSeven from "./pages/seven/CardsSeven";
import { ScriptsSeven, BonusSeven } from "./pages/seven/ScriptsAndBonus";
import LandingNabd from "./pages/nabd/LandingNabd";
import CheckoutNabd from "./pages/nabd/CheckoutNabd";
import SuccessNabd from "./pages/nabd/SuccessNabd";
import NsaveCardLanding from "./pages/nsave/NsaveCardLanding";
import TermsOfService from "./pages/legal/TermsOfService";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import RefundPolicy from "./pages/legal/RefundPolicy";
import Checkout from "./pages/Checkout";
import Success from "./pages/Success";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

function App() {
  // replyrescue.app serves the Reply Rescue funnel at the root.
  const isReplyDomain = window.location.hostname.includes("replyrescue");
  return (
    <div className="App" dir="rtl" lang="ar">
      <BrowserRouter>
        <Routes>
          {/* AI Work Upgrade — primary URL. Update all TikTok / Meta ads to point here. */}
          <Route path="/aicourse" element={<LandingAI />} />
          {/* /course — legacy alias kept for existing creatives. */}
          <Route path="/course" element={<LandingAI />} />
          {/* Root: Reply Rescue landing on replyrescue.app, AI course redirect elsewhere. */}
          <Route path="/" element={isReplyDomain ? <LandingReply /> : <Navigate to="/aicourse" replace />} />
          {/* Legacy Blue Book Gulf landing — kept reachable for archive / TikTok creatives using old URL */}
          <Route path="/bluebook" element={<Landing />} />
          {/* ثابت (Thabit) — new Gulf brand replacing Blue Book at /gulf */}
          <Route path="/gulf" element={<LandingGulf />} />
          <Route path="/about" element={<GulfAbout />} />
          <Route path="/sample" element={<GulfSample />} />
          <Route path="/community" element={<GulfCommunity />} />
          <Route path="/refund" element={<GulfRefund />} />
          <Route path="/contact" element={<GulfContact />} />
          <Route path="/eg" element={<LandingEg />} />
          <Route path="/eg/about" element={<EgAbout />} />
          <Route path="/eg/refund" element={<EgRefund />} />
          <Route path="/eg/community" element={<EgCommunity />} />
          <Route path="/eg/sample" element={<EgSample />} />
          <Route path="/eg/contact" element={<EgContact />} />
          <Route path="/pink" element={<LandingPink />} />
          {/* Reply Rescue — replyrescue.app */}
          <Route path="/reply" element={<LandingReply />} />
          <Route path="/reply/session/:token" element={<ReplySession />} />
          <Route path="/session/:token" element={<ReplySession />} />
          {/* IPO Access Dossier — single-product email-gated funnel */}
          <Route path="/ipoaccess" element={<LandingIPO />} />
          <Route path="/ipoaccess/checkout" element={<IPOCheckout />} />
          <Route path="/ipoaccess/success/:token" element={<IPODownload />} />
          {/* Performance Ads OS — Arabic RTL course funnel (99 SAR) */}
          <Route path="/perfads" element={<LandingCourse />} />
          <Route path="/perfads/checkout" element={<CourseCheckout />} />
          <Route path="/perfads/success/:token" element={<CourseDownload />} />
          <Route path="/perfads/admin" element={<PerfAdsAdmin />} />
          {/* 7 ليالي بيننا — Gulf couples digital experience (99/149/199 SAR) */}
          <Route path="/7days" element={<LandingSeven />} />
          <Route path="/7days/checkout" element={<CheckoutSeven />} />
          <Route path="/7days/success/:token" element={<SuccessSeven />} />
          <Route path="/7days/dashboard" element={<DashboardSeven />} />
          <Route path="/7days/dashboard/newlyweds" element={<ProgramSeven />} />
          <Route path="/7days/dashboard/routine-reset" element={<ProgramSeven />} />
          <Route path="/7days/dashboard/cards" element={<CardsSeven />} />
          <Route path="/7days/dashboard/scripts" element={<ScriptsSeven />} />
          <Route path="/7days/dashboard/bonus" element={<BonusSeven />} />
          {/* نبض السوق AI — Gulf market companion app (149 SAR launch) */}
          <Route path="/nabd" element={<LandingNabd />} />
          <Route path="/nabd/checkout" element={<CheckoutNabd />} />
          <Route path="/nabd/success/:token" element={<SuccessNabd />} />
          {/* nsave USD card — Arabic RTL card-acquisition landing (EG). Not linked from any other funnel; standalone preview URL for ad-campaign use. */}
          <Route path="/eg/usd-card" element={<NsaveCardLanding />} />
          <Route path="/eg/usd-card/:subpath" element={<NsaveCardLanding />} />
          {/* Legal — Required by payment-gateway verification (Stripe/Moyasar/Tap) */}
          <Route path="/legal/terms" element={<TermsOfService />} />
          <Route path="/legal/privacy" element={<PrivacyPolicy />} />
          <Route path="/legal/refund" element={<RefundPolicy />} />
          <Route path="/checkout/:orderId" element={<Checkout />} />
          <Route path="/success/:orderId" element={<Success />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
